import React, { useState } from 'react';
import { notification } from 'components/ds';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { HelpBox } from '../../../components/HelpBox/HelpBox';
import { pageConfigs } from '../../../configs/pageConfigs';
import { TwoFactorSendCodeComponent } from '../../../components/TwoFactorSendCodeComponent/TwoFactorSendCodeComponent';
import { OtpChannel } from '../../../_types/otp.types';
import { useOtpContext } from '../../../context/OtpContextProvider';
import { useOtpLogic } from '../../../hooks/useOtpLogic';
import { SubtitleOtpRequest } from '../ForgotPasswordOtpRequest/ForgotPasswordOtpRequest.styles';
import { useSchema } from '../../../hooks/useSchema';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import TurnstileCaptcha from 'components/TurnstileCaptcha';

export const OtpRequest: React.FC = () => {
  const { data: pageConfig = {} } = useGetTemplate(
    pageConfigs.otpRequest.template,
  );
  const { selectedChannel, setSelectedChannel } = useOtpContext();
  const {
    displayUserData,
    isLoading,
    handleOtpRequest,
    determineSecurityCodeQuestion,
  } = useOtpLogic();

  const { otpRequestChannelType } = useSchema();

  const [optionsCount, setOptionsCount] = useState<number>(0);
  const [captchaToken, setCaptchaToken] = useState<string>('');
  const [captchaKey, setCaptchaKey] = useState(0);

  const theme = ApiLocalStorage.get('theme') || {};
  const helpBoxConfig = theme?.login?.helpBox;
  const needHelp = !!helpBoxConfig;

  const handleChannelSelect = (channel: OtpChannel) => {
    setSelectedChannel(channel);
  };

  const handleUpdateOptionsCount = (count: number) => {
    setOptionsCount(count);
  };

  const handleVerify = (token: string) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async () => {
    if (!captchaToken) {
      notification.error({
        message: 'Verificação necessária',
        description: 'Por favor, complete a verificação de segurança.',
      });

      return;
    }

    const success = await handleOtpRequest(captchaToken);

    if (!success) {
      setCaptchaToken('');
      setCaptchaKey((prev) => prev + 1);
    }
  };

  return (
    <PageContainer
      title={pageConfig.title}
      navigateBack={pageConfigs.otpRequest.navigateBack()}
      buttonText={pageConfigs.otpRequest.buttonLabel}
      onClick={handleSubmit}
      loading={isLoading}
      disabled={isLoading || !selectedChannel || !captchaToken}
      extraAboveButton={
        needHelp ? (
          <HelpBox
            title={helpBoxConfig?.title}
            description={helpBoxConfig?.description}
            linkText={helpBoxConfig?.linkText}
            linkUrl={helpBoxConfig?.linkUrl}
          />
        ) : undefined
      }
      thereIsButton
    >
      <SubtitleOtpRequest>
        {determineSecurityCodeQuestion(optionsCount)}
      </SubtitleOtpRequest>

      {displayUserData && (
        <TwoFactorSendCodeComponent
          otpRequestChannelType={otpRequestChannelType}
          userData={{
            phoneNumber: displayUserData.phoneNumber,
            email: displayUserData.email,
          }}
          onChannelSelect={handleChannelSelect}
          selectedChannel={selectedChannel}
          updateOptionsCount={handleUpdateOptionsCount}
        />
      )}

      <TurnstileCaptcha onVerify={handleVerify} key={captchaKey} />
    </PageContainer>
  );
};
